import { FC, memo } from 'react';

import { IStepComponentProps } from 'components/ImportCsv/constants';

const SyncVariationsStep: FC<IStepComponentProps> = ({}) => {
  return (
    <div>SyncVariations</div>
  );
};

export default memo(SyncVariationsStep);
